import { render, staticRenderFns } from "./board.vue?vue&type=template&id=4d766418&scoped=true&"
import script from "./board.vue?vue&type=script&lang=js&"
export * from "./board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d766418",
  null
  
)

export default component.exports